<template>
    <ADMResourceLinks></ADMResourceLinks>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ADMResourceLinks = defineAsyncComponent(() =>
    import("../../components/ADM/ResourceLinks.vue")
);

export default {
    name: "ADM_Resource_Links", //The name you are in should not equal the name of the component you are importing.
    components: { ADMResourceLinks, AuthLayout },
};
</script>

<style scoped></style>
